import { jsx as _jsx } from "react/jsx-runtime";
import { TwitterEmbed as Twitter } from 'react-social-media-embed';
export const TwitterEmbed = ({ contentInfo }) => {
    return (_jsx("div", { style: { display: 'flex', justifyContent: 'center', width: '100%' }, children: _jsx("div", { style: { maxWidth: 550, overflowX: 'hidden', width: '100%' }, children: _jsx(Twitter, { twitterTweetEmbedProps: {
                    options: {
                        theme: 'dark',
                    },
                    tweetId: contentInfo.statusId,
                }, url: contentInfo.url, width: "100%" }) }) }));
};
//# sourceMappingURL=TwitterEmbed.js.map